import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";
import PurchaseOrderEditPage from "../../../../../entities/DashboardPage/AccountingModule/Purchase/PurchaseOrderEdit";

const PurchaseOrderEdit = () => {
  const [itemList, setItemList] = useState();
  const [supplierList, setSupplierList] = useState();
  const [PurchaseOrder, setPurchaseOrder] = useState({});
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    getItem();
    getSupplierList();
  }, []);

  const handleUpdatePurchaseOrder = async (id, payload) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.updatePurchaseOrder(id, payload);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/purchaseOrder");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getSupplierList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSupplier(text, sort, page);
      if (result?.success) {
        setSupplierList(result?.data?.suppliers);
      }
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  
  const getItem = async (text) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getItemsList(text);
      if (result?.success) {
        setItemList(result?.data?.items);
      }
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getOnePurchaseOrderHandler = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOnePurchaseOrder(id);
      if (result?.success) {
        setPurchaseOrder(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  return (
    <PurchaseOrderEditPage itemList={itemList} handleEdit={handleUpdatePurchaseOrder} handleItemList={getItem} supplierList={supplierList} PurchaseOrder={PurchaseOrder} getOnePurchaseOrderHandler={getOnePurchaseOrderHandler}/>
  )

}

export default PurchaseOrderEdit;
